import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PlusMultIcon from '../../icons/PlusMultIcon';

function NoAssessmentsOnboarding({ canEdit }) {
  return (
    <div className="dashboard-cta">
      {canEdit ? (
        <Fragment>
          <h3 className="dashboard-cta__heading">Start Your First Assessment</h3>
          <div className="dashboard-cta__button-wrapper">
            <Link to="/assessments/new" className="dashboard-cta__add-button">
              <PlusMultIcon option="large" blueBackground />
            </Link>
          </div>
        </Fragment>
      ) : (
        <h3 className="dashboard-cta__heading">No Assessments</h3>
      )}
      <p className="dashboard-cta__text">
        {canEdit
          ? 'Start an assessment to better understand your institution’s injectable medication practices and identify opportunitites for\xa0improvement.'
          : 'You don’t have any assessments to view just yet. After someone from your institution starts an assessment, it will appear\xa0here.'
        }
      </p>
    </div>
  );
}

export default NoAssessmentsOnboarding;



// WEBPACK FOOTER //
// ./src/components/features/dashboard/NoAssessmentsOnboarding.js